import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AssetHyperlinksComponent } from "@app/assetmanagement/components/asset-hyperlinks/asset-hyperlinks.component";
import { ToggleGroupComponent } from "@app/shared/organisms/toggle-group/toggle-group.component";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/assetmanagement/i18n/scope";
import { AssetManagementModel } from "@models/assetmanagement/assetmanagementmodel";

@Component({
    selector: "app-asset-document-hyperlink-toggle",
    templateUrl: "./asset-document-hyperlink-toggle.component.html",
    imports: [ToggleGroupComponent, AssetHyperlinksComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class AssetDocumentHyperlinkToggleComponent implements OnInit{
    @Input() model: AssetManagementModel;
    @Input() canEdit: boolean = true;
    @Output() hyperlinksChanged: EventEmitter<AssetManagementModel> = new EventEmitter<AssetManagementModel>();

    protected selectedTab: string = "hyperlinks";

    private _translation = injectTranslation(scope);
    

    async ngOnInit(): Promise<void> {
        await this._translation.ready();
    }
}
    